import globalAxios from "../../../util/Api";
import { GET_CATEGORIES, DELETE_CATEGORY, NEW_CATEGORY, EDIT_CATEGORIES, GET_ACCESS_RIGHTS, START_LOADING, STOP_LOADING, ERROR } from "./types";
import { StopLoading } from "../../Users/usersAction";
import { LogoutAction } from "../../../actions";

export const GetCategories = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/categories`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_CATEGORIES, payload: res.data.categories })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const EditCategories = (dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('category[name]', dataObj.categoryField);
  bodyFormData.append('category[access_right_attributes][system_settings]', dataObj.systemSettings);
  bodyFormData.append('category[access_right_attributes][user_categories]', dataObj.userCategories);
  bodyFormData.append('category[access_right_attributes][consultant_functions]', dataObj.consultantFunctions);
  bodyFormData.append('category[access_right_attributes][consultant_categories]', dataObj.consultantCategories);
  bodyFormData.append('category[access_right_attributes][users]', dataObj.users);
  bodyFormData.append('category[access_right_attributes][classifications]', dataObj.classifications);
  bodyFormData.append('category[access_right_attributes][branches]', dataObj.branches);
  bodyFormData.append('category[access_right_attributes][themes]', dataObj.theme);
  bodyFormData.append('category[access_right_attributes][countries]', dataObj.countries);
  bodyFormData.append('category[access_right_attributes][public_holidays]', dataObj.publicHolidays);
  bodyFormData.append('category[access_right_attributes][customers]', dataObj.customers);
  bodyFormData.append('category[access_right_attributes][project_planning_all_over]', dataObj.project_planning_all_over);
  bodyFormData.append('category[access_right_attributes][projects_basedata_for_own]', dataObj.projectsBaseDataOwn);
  bodyFormData.append('category[access_right_attributes][projects_setting_for_own]', dataObj.projectsSettingOwn);
  bodyFormData.append('category[access_right_attributes][projects_fee_for_own]', dataObj.projectsFeeOwn);
  bodyFormData.append('category[access_right_attributes][projects_capacity_for_own]', dataObj.projectsCapacityOwn);
  bodyFormData.append('category[access_right_attributes][projects_consultants_for_own]', dataObj.projectsConsultantsOwn);
  bodyFormData.append('category[access_right_attributes][projects_invoices_for_own]', dataObj.projectsInvoicesOwn);
  bodyFormData.append('category[access_right_attributes][projects_basedata_for_other]', dataObj.projectsBasedataForOther);
  bodyFormData.append('category[access_right_attributes][projects_setting_for_other]', dataObj.projectsSettingOther);
  bodyFormData.append('category[access_right_attributes][projects_fee_for_other]', dataObj.projectsFeeOther);
  bodyFormData.append('category[access_right_attributes][projects_capacity_for_other]', dataObj.projectsCapacityOther);
  bodyFormData.append('category[access_right_attributes][projects_consultants_for_other]', dataObj.projectsConsultantsOther);
  bodyFormData.append('category[access_right_attributes][projects_invoices_for_other]', dataObj.projectsInvoicesOther);
  bodyFormData.append('category[access_right_attributes][projects_activity_for_own]', dataObj.projectActivityOwn);
  bodyFormData.append('category[access_right_attributes][projects_activity_for_other]', dataObj.projectActivityOther);
  bodyFormData.append('category[access_right_attributes][projects_planning_for_own]', dataObj.projectPlanningForOwn);
  bodyFormData.append('category[access_right_attributes][projects_planning_for_other]', dataObj.projectPlanningForOther);
  bodyFormData.append('category[access_right_attributes][leads]', dataObj.leads);
  bodyFormData.append('category[access_right_attributes][time_reg_for_own]', dataObj.timeRegistrationOwn);
  bodyFormData.append('category[access_right_attributes][time_reg_other_consultants_other]', dataObj.timeRegistrationOther);
  bodyFormData.append('category[access_right_attributes][months_plan]', dataObj.monthsPlan);
  bodyFormData.append('category[access_right_attributes][consultant_plan]', dataObj.consultantPlan);
  bodyFormData.append('category[access_right_attributes][consultant_plan_for_own]', dataObj.consultantPlanOwn);
  bodyFormData.append('category[access_right_attributes][year_overview_customers]', dataObj.yearOverviewCustomers);
  bodyFormData.append('category[access_right_attributes][year_overview_projects]', dataObj.yearOverviewProjects);
  bodyFormData.append('category[access_right_attributes][year_overview_consultants]', dataObj.yearOverviewConsultants);
  bodyFormData.append('category[access_right_attributes][year_overview_students]', dataObj.yearOverviewStudents);
  bodyFormData.append('category[access_right_attributes][year_overview_themes]', dataObj.yearOverviewThemes);
  bodyFormData.append('category[access_right_attributes][year_overview_leads]', dataObj.yearOverviewLeads);
  bodyFormData.append('category[access_right_attributes][year_overview_vacation]', dataObj.vacationOverview);
  bodyFormData.append('category[access_right_attributes][year_overview_resource_planning]', dataObj.ressourcePlanning);
  bodyFormData.append('category[access_right_attributes][archive]', dataObj.archive);


  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/categories/${dataObj.categoryId}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: EDIT_CATEGORIES, payload: res.data })
          dispatch(GetCategories())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const CreateCategories = (dataObj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('category[name]', dataObj.categoryField);
  bodyFormData.append('category[access_right_attributes][system_settings]', dataObj.systemSettings);
  bodyFormData.append('category[access_right_attributes][user_categories]', dataObj.userCategories);
  bodyFormData.append('category[access_right_attributes][consultant_functions]', dataObj.consultantFunctions);
  bodyFormData.append('category[access_right_attributes][consultant_categories]', dataObj.consultantCategories);
  bodyFormData.append('category[access_right_attributes][users]', dataObj.users);
  bodyFormData.append('category[access_right_attributes][classifications]', dataObj.classifications);
  bodyFormData.append('category[access_right_attributes][branches]', dataObj.branches);
  bodyFormData.append('category[access_right_attributes][themes]', dataObj.theme);
  bodyFormData.append('category[access_right_attributes][countries]', dataObj.countries);
  bodyFormData.append('category[access_right_attributes][public_holidays]', dataObj.publicHolidays);
  bodyFormData.append('category[access_right_attributes][customers]', dataObj.customers);
  bodyFormData.append('category[access_right_attributes][project_planning_all_over]', dataObj.project_planning_all_over);
  bodyFormData.append('category[access_right_attributes][projects_basedata_for_own]', dataObj.projectsBaseDataOwn);
  bodyFormData.append('category[access_right_attributes][projects_setting_for_own]', dataObj.projectsSettingOwn);
  bodyFormData.append('category[access_right_attributes][projects_fee_for_own]', dataObj.projectsFeeOwn);
  bodyFormData.append('category[access_right_attributes][projects_capacity_for_own]', dataObj.projectsCapacityOwn);
  bodyFormData.append('category[access_right_attributes][projects_consultants_for_own]', dataObj.projectsConsultantsOwn);
  bodyFormData.append('category[access_right_attributes][projects_invoices_for_own]', dataObj.projectsInvoicesOwn);
  bodyFormData.append('category[access_right_attributes][projects_basedata_for_other]', dataObj.projectsBasedataForOther);
  bodyFormData.append('category[access_right_attributes][projects_setting_for_other]', dataObj.projectsSettingOther);
  bodyFormData.append('category[access_right_attributes][projects_fee_for_other]', dataObj.projectsFeeOther);
  bodyFormData.append('category[access_right_attributes][projects_capacity_for_other]', dataObj.projectsCapacityOther);
  bodyFormData.append('category[access_right_attributes][projects_consultants_for_other]', dataObj.projectsConsultantsOther);
  bodyFormData.append('category[access_right_attributes][projects_invoices_for_other]', dataObj.projectsInvoicesOther);
  bodyFormData.append('category[access_right_attributes][projects_activity_for_own]', dataObj.projectActivityOwn);
  bodyFormData.append('category[access_right_attributes][projects_activity_for_other]', dataObj.projectActivityOther);
  bodyFormData.append('category[access_right_attributes][projects_planning_for_own]', dataObj.projectPlanningForOwn);
  bodyFormData.append('category[access_right_attributes][projects_planning_for_other]', dataObj.projectPlanningForOther);
  bodyFormData.append('category[access_right_attributes][leads]', dataObj.leads);
  bodyFormData.append('category[access_right_attributes][time_reg_for_own]', dataObj.timeRegistrationOwn);
  bodyFormData.append('category[access_right_attributes][time_reg_other_consultants_other]', dataObj.timeRegistrationOther);
  bodyFormData.append('category[access_right_attributes][months_plan]', dataObj.monthsPlan);
  bodyFormData.append('category[access_right_attributes][consultant_plan]', dataObj.consultantPlan);
  bodyFormData.append('category[access_right_attributes][consultant_plan_for_own]', dataObj.consultantPlanOwn);
  bodyFormData.append('category[access_right_attributes][year_overview_customers]', dataObj.yearOverviewCustomers);
  bodyFormData.append('category[access_right_attributes][year_overview_projects]', dataObj.yearOverviewProjects);
  bodyFormData.append('category[access_right_attributes][year_overview_consultants]', dataObj.yearOverviewConsultants);
  bodyFormData.append('category[access_right_attributes][year_overview_students]', dataObj.yearOverviewStudents);
  bodyFormData.append('category[access_right_attributes][year_overview_themes]', dataObj.yearOverviewThemes);
  bodyFormData.append('category[access_right_attributes][year_overview_leads]', dataObj.yearOverviewLeads);
  bodyFormData.append('category[access_right_attributes][year_overview_resource_planning]', dataObj.ressourcePlanning);
  bodyFormData.append('category[access_right_attributes][year_overview_vacation]', dataObj.vacationOverview);
  bodyFormData.append('category[access_right_attributes][archive]', dataObj.archive);


  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/categories`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: NEW_CATEGORY, payload: res.data.errors })
          dispatch(GetCategories())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const GetAccessRights = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/categories/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_ACCESS_RIGHTS, payload: res.data })
          dispatch(StopLoading())
        }
      }).catch(err => {

      })
  }
}
export const DeleteCategory = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/categories/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_CATEGORY })
          dispatch(GetCategories())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
